import React from "react";
import { Box } from "@mui/material";
import { useQuery } from "@apollo/client/react";
import BillingDashboard from "../components/BillingDashboard";
import { ME } from "../graphql/query";
import type { MeQueryResponse } from "../interfaces/auth.interface";

const BillingPage: React.FC = () => {
  const { data, loading } = useQuery<MeQueryResponse>(ME);
  if (loading) return null;

  const role = data?.me?.role;
  if (role !== "SUPER_ADMIN") {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "18px",
          fontWeight: 800,
          minHeight: "calc(100vh - 160px)",
        }}
      >
        Unauthorized
      </Box>
    );
  }

  return <BillingDashboard />;
};

export default BillingPage;

